export const COLORS: Record<string, string> = {
  primaryMain: '#191919',
  primaryLight: '#F5F5F5',
  primaryDark: '#ADADAD',
  secondaryMain: '#4C85B9',
  secondaryLight: '#EFF9FC',
  secondaryDark: '#FFFFFF',
  actionDisabled: '#CCCCCC',
  backgroundDefault: '#FCFCFC',
  backgroundPaper: '#FFFFFF',
  backgroundDark: '#666666',
  infoMain: '#E0E0E0',
  infoLight: '#EEEEEE',
  errorMain: '#FF4141',
  errorLight: '#FFA3A3',
  successMain: '#007E33',
  successLight: '#E7F4E7',
  warningMain: '#FFC030',
  warningLight: '#FFE099',
  black: '#000000',
  white: '#FFFFFF',
  oktaBackground: '#1A3768',
};

export const ACCENT_COLORS: string[] = [
  '#305D86',
  '#416C93',
  '#527BA0',
  '#638AAD',
  '#7398B9',
  '#84A7C6',
  '#95B6D3',
  '#A6C5E0',
  '#B6D3EC',
];

export const ACCENT_COLORS_SHORT: string[] = [
  ACCENT_COLORS[0],
  ACCENT_COLORS[1],
  ACCENT_COLORS[3],
  ACCENT_COLORS[5],
  ACCENT_COLORS[7],
];

export const ACCENT_COLORS_CONTRAST: string[] = [
  ACCENT_COLORS[0],
  ACCENT_COLORS[3],
  ACCENT_COLORS[5],
  ACCENT_COLORS[7],
];

export const DEFAULT_CHART_COLOR: string = ACCENT_COLORS[2];

export const CHART_COLORS: string[] = [
  '#8FD1FF',
  '#B0EAB0',
  '#EAD3A2',
  '#BEB1E3',
  '#FDB2AD',
  '#E8E8A3',
  '#DEA2E4',
  '#9EABE6',
  '#CAB595',
  '#90CACA',
  '#A4C184',
  '#E8A6BD',
  '#D1DFAA',
];

export const GANTT_CHART_COLOR_LIST: GanttChartColorItem[] = [
  {
    id: 1,
    name: DEFAULT_CHART_COLOR,
    title: 'Default',
  },
  {
    id: 2,
    name: CHART_COLORS[0],
    title: 'Blue',
  },
  {
    id: 3,
    name: CHART_COLORS[1],
    title: 'Green',
  },
  {
    id: 4,
    name: CHART_COLORS[2],
    title: 'Orange',
  },
  {
    id: 5,
    name: CHART_COLORS[3],
    title: 'Purple',
  },
  {
    id: 6,
    name: CHART_COLORS[4],
    title: 'Red',
  },
  {
    id: 7,
    name: CHART_COLORS[5],
    title: 'Yellow',
  },
  {
    id: 8,
    name: CHART_COLORS[6],
    title: 'Pink',
  },
];
